import { render, staticRenderFns } from "./NewInsurer.vue?vue&type=template&id=48b962e3&scoped=true"
import script from "./NewInsurer.vue?vue&type=script&lang=js"
export * from "./NewInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b962e3",
  null
  
)

export default component.exports